import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable, MASK_DATE, MASK_DECIMAL, MASK_MONEY, MASK_NUMBER, MASK_NUMBER_ROUND } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { _CreditAccountvdos } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { AccountEditor } from "../../../../editor/AccountEditor";
import usePaginator from "../../../../theme/Component/usePaginator";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { HistoryCreditInfo } from "../../../../../portal/componets/pages/IndexPage/Components/ActiveCredits/Components/HistoryCreditInfo";
import { AmortizationCreditInfo } from "../../../../../portal/componets/pages/IndexPage/Components/ActiveCredits/Components/AmortizationCreditInfo";
import { PersonalAccountData } from "../../../../../portal/componets/pages/IndexPage/Components/PersonarDataUser/PersonalAccountData";
import useModal, { MODAL_md, MODAL_SM, MODAL_XL } from "../../../../theme/Component/hooks/useModal";
import { CuotaMes } from "./CuotaMes";
import { ActualizarCartera } from "./ActualizarCartera";
import { _CreditAccount, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { ActualizarCarteraDatos } from "./ActualizarCarteraDatos";
import { DropDown } from "../../../../theme/Component/DropDown";
import { ExportXLSL } from "../../../../theme/Component/ExportXLSX";
import AutoChart from "../../../../../core/graph/AutoChart";
import { YearSelector } from "../../../../../core/shared/inputs/YearSelector";
import { SelectMonths } from "../../../../contract/select/SelectMonths";
import { ActualizarDatos } from "./ActualizarDatos";
import { LoanLineEditor } from "../../../../admin/CreditPotfolio/LoanLine/LoanLineEditor";
import { PayrollEntitySelect } from "../../../../admin/CreditPotfolio/PayrollEntity/PayRollEntitySelect";
import { PrintJson } from "../../../../theme/Component/PrintJson";


export const CreditAccountvdos = () => {

    const { instance, setBean, bean, lista, setLista } = useDataBean(_CreditAccountvdos);
    const _credito = useDataBean(_CreditAccount);
    const single = Singleton.getInstance();
    const [state, setState] = useState<any>(724);
    const [modalmovimiento, setModalmovimiento] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [modalamoritizar, setModalAmortizar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalInfo, setModalInfo] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [props, setProps] = useState<string>("");
    const [reportPay, setReportPay] = useState<any>({});
    const [reportCentral, setReportCentral] = useState<any>({});

    const paginador = usePaginator();
    const [records, setRecords] = useState<number>(15);
    const modalCargar = useModal("CargarCartera", MODAL_md);
    const modalCargarDatos = useModal("Actualizar Datos Cartera", MODAL_md);
    const modalCuotaMes = useModal("Cuota Mes", MODAL_md);
    const modalDownload = useModal("Consolidado", MODAL_SM);
    const modalDownload2 = useModal("Reporte", MODAL_SM);
    const modalGraph = useModal("Grafica", MODAL_XL);
    const modalOption = useModal("Opciones", MODAL_md);
    const modalCentral = useModal("Central de Riesgo", MODAL_SM);

    const [listaAll, setListaAll] = useState<any>([]);
    const [filter, setFilter] = useState<any>({
        Year: _single.getCurrenYear(),
        Month: _single.getCurrentMonth(),
        State: state,
        IDAccount: null,
        IDPayrollEntity: null,
        IDLoanLine: null
    });


    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        // let filter: any = {
        //     State: state,
        //     Year: year,
        //     Month: month,
        // };
        // if (IDAccount > 0) {
        //     filter.IDAccount = IDAccount;
        //     filter.Year = year;
        //     filter.Month = month;
        // }


        instance.getCarteraRender(paginador.page, records, _single.cleanMap(filter)).then(
            (resp: any) => {
                if (resp) {
                    //console.log(resp.NumberOfPages)
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (records));
                    paginador.setRegiPerPage(records)

                    setLista(updateInfo(resp.List));
                    // setLista(resp.List);

                }
            }
        )
    }
    const updateInfo = (lista: any[]) => {

        lista.forEach(element => {
            try {
                element.DataBeanProperties.Edad = _single.calcularEdad(element.DataBeanProperties.BornDate);
                element.DataBeanProperties.TotalVencido =
                    (element.DataBeanProperties.DefeatedCapitalLeft ?? 0) +
                    (element.DataBeanProperties.DefeatedInterest ?? 0) +
                    (element.DataBeanProperties.DefeatedInterestLeft ?? 0);
                // (element.DataBeanProperties.SaldoMoraCapital ?? 0);      

                element.DataBeanProperties.NoObligacion = quitarTresPrimerosDigitos(element.DataBeanProperties.CreditNumber);

            } catch (error) {

            }
        });
        return lista;
    }

    function quitarTresPrimerosDigitos(numero) {
        return String(numero).substring(3);
    }
    const getListaAll = () => {

        // let filter: any = {
        //     State: state,
        //     Year: year,
        //     Month: month,
        // };
        // if (IDAccount > 0) {
        //     filter.IDAccount = IDAccount;
        //     filter.Year = year;
        //     filter.Month = month;
        // }
        instance.getCarteraRender(1, paginador.pages * records, _single.cleanMap(filter)).then(
            (resp: any) => {
                if (resp) {
                    // setListaAll(resp.List)
                    setListaAll(updateInfo(resp.List));
                }
            }
        )
    }
    const getStateCreditPaymentReport = () => {

        let mm = filter.Month + 1;
        let peri = filter.Year + (mm < 10 ? '0' + mm : mm + '');
        let filt: any = {
            IDPayrollEntity: filter.IDPayrollEntity,
            IDLoanLine: filter.IDLoanLines
        };


        instance.getStateCreditPaymentReport(parseInt(peri), _single.cleanMap(filt)).then(
            (resp: any) => {
                if (resp) {
                    // setListaAll(resp.List)
                    setReportPay(resp.Docs);
                    console.log(resp.Docs);
                    modalDownload2.open();

                }
            }
        )
    }

    const head = [
        { title: 'Cuenta Capital', property: 'AccountantCapital', visible: true },
        { title: 'No. Credito', property: 'CreditNumber', visible: true, mask: MASK_NUMBER },
        { title: 'Identificación', property: 'Nit', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre', property: 'DeudorName', visible: true },
        { title: 'Caja Nominadora', property: 'CajaNominadora', visible: true },
        { title: 'Fecha Nacimiento', property: 'BornDate', visible: true, mask: MASK_DATE },
        { title: 'Edad', property: 'Edad', visible: true },
        { title: 'Grado', property: 'GradoPersona', visible: true },
        { title: 'Dirección', property: 'DireccionResidencia', visible: true },
        { title: 'Ciudad', property: 'Ciudad', visible: true },
        { title: 'Departamento', property: 'Departamento', visible: true },
        { title: 'Telefono 1', property: 'TelefonoVivienda', visible: true },
        { title: 'Telefono 2', property: 'NumeroCelular', visible: true },
        { title: 'Correo', property: 'CorreoPersonal', visible: true },
        { title: 'Tipo Documento', property: 'DocTypeName', visible: true },
        { title: 'Sexo', property: 'GenTypeName', visible: true },
        { title: 'Tipo Obligación', property: 'LoanNumberPrefix', visible: true, mask: MASK_NUMBER },
        { title: 'No. Obligacion', property: 'NoObligacion', visible: true },
        { title: 'Monto Solicitado', property: 'AmountCredit', visible: true, mask: MASK_MONEY },
        { title: 'Saldo Capital', property: 'CurrentCapitalLeft', visible: true, mask: MASK_MONEY },
        { title: 'Dias Vencido', property: 'DiasCastigo', visible: true },
        { title: 'Vencido Interes', property: 'DefeatedInterestLeft', visible: true, mask: MASK_MONEY },//interes corriente
        { title: 'Vencido Interes Mora', property: 'DefeatedInterest', visible: true, mask: MASK_MONEY },//interes mora vencido
        { title: 'Vencido Capital', property: 'DefeatedCapitalLeft', visible: true, mask: MASK_MONEY },
        { title: 'Total Vencido', property: 'TotalVencido', visible: true, mask: MASK_MONEY },
        { title: 'Tasa Corriente', property: 'RateValueCredit', visible: true, mask: MASK_DECIMAL },
        // { title: 'Tasa Mora', property: 'RateValueMora', visible: true, mask: MASK_DECIMAL },
        { title: 'Linea Credito', property: 'NameLoanLine', visible: true },
        // { title: 'Destino Credito', property: 'DestinoCredito', visible: true },
        { title: 'Provision Capital', property: 'ProvisionCapital', visible: true, mask: MASK_MONEY },
        { title: 'Provision Interes', property: 'ProvisionInteres', visible: true, mask: MASK_MONEY },
        { title: 'Fecha Aprovacion', property: 'ApprovalDate', visible: true, mask: MASK_DATE },
        { title: 'Valor Cuota', property: 'CuoteAmount', visible: true, mask: MASK_MONEY },
        { title: 'Total Cuotas', property: 'Cuotes', visible: true, mask: MASK_NUMBER },
        { title: 'Fecha Inicio', property: 'FromDate', visible: true, mask: MASK_DATE },
        { title: 'Fecha Final', property: 'UptoDate', visible: true, mask: MASK_DATE },
        { title: 'Altura', property: 'CuotasPagadasHI', visible: true, mask: MASK_NUMBER },
        { title: 'Fecha Vencimiento', property: 'ExpirationDate', visible: true, mask: MASK_DATE },
        { title: 'Calificacion AntesLey Arrastre', property: 'CalificaAntesLeyArrastre', visible: true },
        { title: 'Calificacion', property: 'CalificacionAplicada', visible: true },
        { title: 'Calificacion mes Anterior', property: 'CalificacionMesAnterior', visible: true },
        { title: 'Interes Corriente Orden', property: 'InteresCorrienteOrden', visible: true, mask: MASK_MONEY },
        { title: 'Interes Mora Orden', property: 'InteresMoraOrden', visible: true, mask: MASK_MONEY },
        { title: 'Fecha Ultimo Pago', property: 'FechaUltimoPago', visible: true, mask: MASK_DATE },
        { title: 'Nit Codeudor', property: 'NitCodeudor', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre Codeudor', property: 'CoDeudorName', visible: true },
        { title: 'Garantia', property: 'Garantia', visible: true },
        { title: 'Periodo', property: 'Periodo', visible: true, mask: MASK_NUMBER },
        { title: 'Estado', property: 'StateName', visible: false },


    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Movimientos', icono: 'ri-folder-open-line', visible: single.canEdit(), evento: () => { setModalmovimiento({ ...modalmovimiento, "view": true, name: `Historial del Credito de ${bean.DeudorName}` }) } },
            { titulo: 'Amortización', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalAmortizar({ ...modalamoritizar, "view": true, name: `Amortizaciones del Credito de ${bean.DeudorName}` }) } },
            { titulo: 'Informacion del Deudor', icono: 'ri-search-2-line', visible: true, evento: () => { openModal("IDAccount") } },
            // { titulo: 'Sincronizar', icono: 'ri-refresh-line', visible: _single.canCreate(), evento: () => { sincronizarAffiliate() } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const sincronizarAffiliate = () => {
        _credito.instance.migrateCreditosAffiliado(bean.IDCreditAffiliate).then(
            (resp: any) => {
                toast.success("Tarea realizada");
            }
        )
    }
    const getCifinReport = () => {
        _credito.instance.getCifinReport(_single.getAccountID(), filter.Year, filter.Month, _single.cleanMap(filter)).then(
            (resp: any) => {
                console.log(resp);
                if (resp.Report) {
                    toast.success("Tarea realizada");
                    setReportCentral(resp.Report?.DataBeanProperties);

                }
                modalCentral.open();

            }
        )
    }


    const openModal = (prop: "IDAccount" | "IDAccountCodeudor") => {
        setProps(prop);
        setModalInfo({ ...modalInfo, "view": true });
    };

    useEffect(() => {
        if (props && bean[props]) {
            setModalInfo({
                ...modalInfo,
                view: true,
                name: props === "IDAccount" ? "Información del deudor" : "Información del codeudor"
            });
        }
    }, [props]);

    const actionsDropDown = [
        { id: 1, name: 'Descargar Detalle Cartera', permiso: null, activo: true },
        { id: 2, name: 'Reporte Gráfico', permiso: null, activo: true },
        { id: 3, name: 'Reporte Pagos Cartera', permiso: null, activo: true },
        { id: 4, name: 'Archivo central de riesgos', permiso: null, activo: _single.canCreate() },
        // {id:2,name:'Ver Documentos',permiso:null,activo:false},  
    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id == 1) {
                            getListaAll();
                            modalDownload.open();
                        }
                        else if (e.id == 2) {
                            getListaAll();
                            modalGraph.open();
                        }
                        else if (e.id == 3) {
                            getStateCreditPaymentReport();
                            // modalDownload.open();
                        }
                        else if (e.id == 4) {
                            getCifinReport();
                        }
                    }}></DropDown>
                </div>
            </div>
        )
    }

    return (
        <BasicPage titulo="Listado Cartera">
            <div className="row">
                {_single.canCreate() &&
                    <div className="col-md-12">
                        <BasicButton icon="" useMargin eventClick={() => { modalCargar.open() }}>Cargar Cartera</BasicButton>
                        <BasicButton icon="" useMargin eventClick={() => { modalCuotaMes.open() }}>Cuota Mes</BasicButton>
                        <BasicButton icon="" useMargin eventClick={() => { modalCargarDatos.open() }}>Actualizar Cartera</BasicButton>
                        <BasicButton icon="" useMargin eventClick={() => { modalOption.open() }}>Datos</BasicButton>
                    </div>
                }
                <div className="col-md-2">
                    <YearSelector tittle="Año" value={filter.Year} onChange={(e) => { setFilter({ ...filter, "Year": e }) }} />
                </div>
                <div className="col-md-2">
                    <SelectMonths label="Mes" idSelector={filter.Month} onChange={(e) => { setFilter({ ...filter, "Month": e }) }} />
                </div>
                <div className="col-md-4">
                    <AccountEditor idAccount={filter.IDAccount} onChange={(e) => { setFilter({ ...filter, "IDAccount": e.IDAccount }) }} label="Tercero" />
                </div>
                <div className="col-md-4">
                    <LoanLineEditor multiSelect label="Linea" onChange={(e) => { setFilter({ ...filter, "IDLoanLines": e?.IDList }) }} />
                </div>
                <div className="col-md-4">
                    <PayrollEntitySelect label="Caja Nominadora" idSelector={filter.IDPayrollEntity} onChange={(e) => { setFilter({ ...filter, "IDPayrollEntity": e }) }} returnType="ID" />
                </div>
                <div className="col-md-2">
                    <label>Estado</label>
                    <select className="form-select" value={filter.State} onChange={(e) => { setFilter({ ...filter, "State": parseInt(e.target.value ?? null) }) }}>
                        <option value={null}>...</option>
                        <option value={724}>VIGENTE</option>
                        <option value={725}>CANCELADO</option>
                    </select>
                </div>
                <div className="col-md-4">
                    <BasicButton value="Buscar" useMargin icon="ri-file-add-line" eventClick={getLista} ></BasicButton>
                    {/* <BasicButton value="limpiar" clase="danger" useMargin icon="" eventClick={()=>{setFilter({IDLoanLine:null,IDPayrollEntity:null})}} ></BasicButton> */}
                </div>
                <div className="col-md-12">
                    <BasicTable
                        body={lista}
                        head={head}
                        rowSet={setBean}
                        listButtons={listaBotones()}
                        headButtons={buttons()}
                        next={paginador.next}
                        pageTop={paginador.page}
                        back={paginador.back}
                        records={paginador}
                    />

                    <Modal modal={modalCentral.modal} updateModal={modalCentral.setModal}>
                        <div>
                            {reportCentral?.URL ?
                                <a href={reportCentral.URL} className="link" target="_blank">Descargar Reporte</a>
                                :
                                <p>No hay reporte</p>
                            }
                            {/* <PrintJson json={reportCentral} /> */}
                        </div>
                    </Modal>
                    <Modal modal={modalCargar.modal} updateModal={modalCargar.setModal}>
                        <div>
                            <p>Actializar Cartera</p>
                            <ActualizarCartera />
                        </div>
                    </Modal>
                    <Modal modal={modalCargarDatos.modal} updateModal={modalCargarDatos.setModal}>
                        <div>
                            <p>Actualizar Cartera Datos</p>
                            <ActualizarCarteraDatos />
                        </div>
                    </Modal>
                    <Modal modal={modalCuotaMes.modal} updateModal={modalCuotaMes.setModal}>
                        <CuotaMes />
                    </Modal>
                    <Modal modal={modalmovimiento} updateModal={setModalmovimiento} >
                        <div className="row">
                            <div className="col-md-12">
                                <HistoryCreditInfo Credit={bean} _idAccount={bean.IDAccount} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalOption.modal} updateModal={modalOption.setModal} >
                        <div className="row">
                            <div className="col-md-12">
                                <ActualizarDatos />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalamoritizar} updateModal={setModalAmortizar} >
                        <div className="row">
                            <div className="col-md-12">
                                <AmortizationCreditInfo Credit={bean} _idAccount={bean.IDAccount} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalInfo} updateModal={setModalInfo}>
                        <div className="row">
                            <div className="col-md-12">
                                <PersonalAccountData idAffiliate={bean[props]} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalDownload.modal} updateModal={modalDownload.setModal}>
                        <div className="row">
                            <div className="col-md-12">
                                {listaAll.length > 0 &&
                                    <ExportXLSL customName={'cartera'} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaAll} onExport={(name: string) => {
                                        single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                                    }} />
                                }
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalDownload2.modal} updateModal={modalDownload2.setModal}>
                        <div className="row">
                            <div className="col-md-12">
                                {reportPay.DataBeanProperties?.URL ?
                                    <a href={reportPay.DataBeanProperties.URL} target="_blank" className="link">{reportPay.DataBeanProperties.Name}</a>
                                    :
                                    <strong>No hay reportes pendientes</strong>
                                }
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                        <AutoChart data={listaAll} head={head} useIndexAsXLabel={true}
                            xOptions={['NameLoanLine', 'CajaNominadora', 'GenTypeName', 'DocTypeName', 'Ciudad', 'Departamento']}
                            yOptions={['AmountCredit', 'SaldoCapital', 'SaldoMoraInteres', 'VencidoInteresMora', 'SaldoMoraCapital']} />

                    </Modal>

                </div>

            </div>
        </BasicPage>
    )
}